<template>
  <vs-popup class="popup-select-891"
    title="공정활동분류표"
    :active.sync="showPopup">
    <page891 ref="page891" mode="popup" @close="showPopup = false;" @select="onSelect"/>
  </vs-popup>
</template>

<script>
import page891 from "@/views/boards/single-page/891/Page.vue";
export default {
  components: {
    page891
  },
  props: {
    value: Boolean,
  },
  watch: {
    value (val) {
      if (!val) {
        this.$refs.page891.reset();
      } else {
        this.$refs.page891.loadListBoard();
      }
    }
  },
  computed: {
    showPopup: {
      get () {
        return this.value;
      },
      set (val) {
        this.$emit('input', val);
      },
    }
  },
  data () {
    return {
    }
  },
  methods: {
    onSelect (model) {
      this.$emit('select', model);
      this.showPopup = false;
    }
  }
}
</script>

<style scoped>

</style>

<style>
.popup-select-891 > .vs-popup {
  width: 1200px !important;
}
</style>
